import React, { Component } from 'react';
import TaskInfo from './TaskInfo/TaskInfo';
import './DetailCard.css';
import 'moment-timezone';
import moment from 'moment';
import axios from 'axios';
import { APIURL } from '../../../../config';
import ArtInfo from './TaskInfo/ArtInfo';
import { Accordion, AccordionSummary, AccordionDetails, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

class DetailCard extends Component {
    state = {
        open: false,
        completedTaskData: [],
        artifacts: []
    }

    async componentDidMount() {
        if (this.props.task) {
            let completedTaskData = await axios(APIURL + '/locate/TimeSpent', { params: { projId: this.props.projId, comp_id: this.props.comp_id } })
            var taskTimeSpent = this.getTimings(completedTaskData.data)
            this.setState({ completedTaskData: taskTimeSpent })
        } else if (this.props.art) {
            let artifactsData = await axios.get(APIURL + "/artifacts?id=" + this.props.projId)

            let artifacts = artifactsData.data.map((art) => {
                const task = this.props.tasks.find(task => art.task_id === task.tas_id)
                const employee = this.props.employee.find(emp => art.employee_id === emp.id)
                if (!employee) {
                    return { ...art, taskName: '', taskType: '', empName: " " }
                }
                if (!!task) {
                    return { ...art, taskName: task.tas_title, taskType: task.tas_type, empName: employee.employee_name }
                } else {
                    return { ...art, taskName: '', taskType: '', empName: employee.employee_name }
                }
            })
            this.setState({
                artifacts: artifacts.filter((art) => !!art.show)
            })
        }
    }

    setOpen = (open) => {
        this.setState({ open })
    }

    showTaskList = () => {
        if (this.props.tasks && this.props.tasks.length > 0) {
            const recentTasks = this.props.tasks
                .filter((task) => task.tas_is_active !== 2)
                .sort((a, b) => moment(b.tas_end_date) - moment(a.tas_end_date))
                .slice(0, 5);
            return recentTasks.map(
                task => <TaskInfo
                    key={task.tas_id}
                    name={task.tas_title}
                    momentCode={this.state.completedTaskData.find((completedTask) => (completedTask.taskId === task.tas_id))}
                    start_date={task.tas_start_date}
                    end_date={task.tas_end_date}
                    is_active={task.tas_is_active}
                />
            )
        } else {
            return <div className='d-flex flex-column justify-content-center align-items-center mt-4'>
                <h5 style={{ fontFamily: 'Lato', fontSize: 18 }}>No Tasks found </h5>
            </div>
        }
    }

    showArtList = () => {
        if (this.state.artifacts.length > 0) {
            const recentArts = this.state.artifacts.slice(-5);
            return recentArts.map(
                art => <ArtInfo
                    key={art.id}
                    data={art}
                />
            )
        } else if (this.state.artifacts.length === 0) {
            return <div className='d-flex flex-column justify-content-center align-items-center mt-4' style={{ height: '300px', margin: 5 }}>
                <h5 style={{ fontFamily: 'Lato', fontSize: 18, marginTop: 28, marginBottom: 28 }}>No Artifacts found </h5>
            </div>
        }
    }

    calCumulativeTimeSpent = () => {
        var TotalTime = moment()
        this.state.completedTaskData.forEach((taskData) => {
            var CheckInTime = moment(taskData.CheckInTime)
            var CheckoutTime = moment(taskData.CheckoutTime)
            var taskTime = moment.duration(CheckoutTime.diff(CheckInTime))
            TotalTime.add(taskTime)
        })
        return moment.duration(TotalTime.diff(moment())).humanize()
    }

    getTimings = (timedata) => {
        let taskdataTimeSpent = !this.props.tasks ? [] : this.props.tasks.filter((item) => (item.tas_is_active !== 2)).filter((task) => (!(task.tas_is_active === 0 && (moment(task.tas_start_date).isAfter(new Date()) || moment(task.tas_end_date).isBefore(new Date()))))).map((task) => {
            let foundTask = timedata.find((fTask) => (fTask.taskId === task.tas_id))
            if (!foundTask) {
                let timeStartHours = parseInt(task.tas_start_time.slice(0, 2));
                let timeEndHours = parseInt(task.tas_end_time.slice(0, 2));
                if (task.tas_start_time.slice(-2) === 'PM' && timeStartHours !== 12) {
                    timeStartHours += 12
                } else if (task.tas_start_time.slice(-2) === 'AM' && timeStartHours === 12) {
                    timeStartHours = 0
                }
                if (task.tas_end_time.slice(-2) === 'PM' && timeEndHours !== 12) {
                    timeEndHours += 12
                } else if (task.tas_end_time.slice(-2) === 'AM' && timeEndHours === 12) {
                    timeEndHours += 12
                }
                if (task.tas_is_active === 0 && moment(task.tas_start_date).isSameOrBefore(new Date())) {
                    if (!timedata.find((Ctask) => (Ctask.taskId === task.tas_id))) {
                        return null
                    } else {
                        return { CheckInTime: moment(task.tas_start_date).add(timeStartHours, 'h'), CheckoutTime: moment(), taskId: task.tas_id }
                    }
                } else {
                    return { CheckInTime: moment(task.tas_start_date).add(timeStartHours, 'h'), CheckoutTime: moment(task.tas_end_date).add(timeEndHours, 'h'), taskId: task.tas_id }
                }
            } else {
                return { CheckInTime: moment(foundTask.CheckInTime), CheckoutTime: moment(foundTask.CheckoutTime), taskId: task.tas_id }
            }
        }).filter((task) => (!!task))
        return taskdataTimeSpent
    }

    render() {
        return (
            <Accordion
                sx={{
                    border: '1px solid #e0ecfa',
                    borderRadius: '8px !important',
                    boxShadow: 'none',
                    mt: 1,
                    '&:before': { display: 'none' },
                    '&.Mui-expanded': { mt: 1 },
                }}
            >
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ fontSize: 18, color: '#888' }} />}
                    sx={{
                        minHeight: '36px !important',
                        px: 1.5,
                        background: '#F9F9F9',
                        borderRadius: '8px',
                        '& .MuiAccordionSummary-content': { my: '8px !important', alignItems: 'center', gap: 1 },
                    }}
                >
                    <i className={this.props.task ? 'far fa-clock' : 'fas fa-briefcase'} style={{ color: '#888', fontSize: 13 }}></i>
                    <div style={{ marginLeft: 8 }}>
                        <Typography sx={{ fontSize: '0.78rem', fontWeight: 800, letterSpacing: '0.06em', color: '#222', textTransform: 'uppercase' }}>
                            {this.props.task ? 'Time Spent on Tasks' : 'Artifacts'}
                        </Typography>
                        {this.props.task && <Typography sx={{ fontSize: '0.74rem', color: '#888' }}>{this.calCumulativeTimeSpent()} over {this.state.completedTaskData.length} tasks</Typography>}
                        {this.props.art && <Typography sx={{ fontSize: '0.74rem', color: '#888' }}>{this.state.artifacts.length} uploads</Typography>}
                    </div>
                </AccordionSummary>
                <AccordionDetails sx={{ p: '4px 8px 8px' }}>
                    <div>
                        {this.props.task && this.showTaskList()}
                        {this.props.art && this.showArtList()}
                    </div>
                </AccordionDetails>
            </Accordion>
        )
    }
}

export default DetailCard;